export const shouldBeRendered = (
  data: unknown,
  conditions: boolean[],
  operator: 'or' | 'and' = 'or'
): boolean => {
  if (!data) return false;

  if (operator === 'or') {
    return conditions.some((c) => c);
  }

  if (operator === 'and') {
    return conditions.every((c) => c);
  }

  return false;
};
